

<template>
  <v-navigation-drawer
    v-model="notificationDrawer"
    style="width: 260px"
    right
    :clipped-left="$vuetify.breakpoint.lgAndUp"
    app
  >
    <v-list-item>
      <v-btn icon class="mr-5" @click="toggleNav(notificationDrawer = !notificationDrawer)">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-list-item-content>
        <v-list-item-title class="text-h2">Notifications</v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-divider></v-divider>
    <div class="pa-5 center">
    <h3>Welcome to Lions District 306c1 CMS.</h3>
    <p></p>
    </div>
  </v-navigation-drawer>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");

export default {
  data() {
    return {
      defaultImage: require("@/assets/img/avatar.svg")
    };
  },

  watch: {
    notificationDrawer(value) {
      this.toggleNav(value);
    }
  },

  computed: {
    ...mapGetters({
      profile: "profile",
      loading: "loading",
      notificationDrawer: "notificationDrawer"
    }),

    notificationDrawer: {
      get() {
        return this.$store.state.auth.notificationDrawer;
      },
      set(value) {
        this.$store.commit("auth/setNotificationDrawer", value);
      }
    }
  },

  methods: {
    logout: function() {
      this.$store.dispatch("auth/destroyToken").then(response => {
        if (response) {
          this.$router.push("/login");
        }
      });
    },
    toggleNav: function(value) {
      this.$store.dispatch("auth/changeNotificationDrawer", value);
    }
  }
};
</script>


